import React, { useEffect, useState, useRef } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';
import { fmtDate } from '@/lib/format';
import { toast } from 'sonner';

export default function TenantMessages() {
  const [lease, setLease] = useState(null);
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const me = JSON.parse(localStorage.getItem('pmcrm_user') || '{}');
  const endRef = useRef(null);

  useEffect(() => {
    api.get('/leases').then(r => {
      const a = r.data.find(l => l.status === 'active') || r.data[0];
      setLease(a);
    });
  }, []);
  useEffect(() => {
    if (lease) api.get('/messages', { params: { lease_id: lease.id } }).then(r => setItems(r.data));
  }, [lease]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [items]);

  const send = async () => {
    if (!text.trim() || !lease) return;
    try {
      const { data } = await api.post('/messages', { lease_id: lease.id, body: text });
      setItems((arr) => [...arr, data]); setText('');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };

  return (
    <div>
      <PageHeader title="Messages" subtitle="Chat with your property consultant" />
      <Card className="flex flex-col h-[60vh] overflow-hidden">
        <div className="flex-1 overflow-auto p-4 space-y-3" data-testid="messages-thread">
          {items.map((m) => {
            const mine = m.sender_id === me.id;
            return (
              <div key={m.id} className={`flex ${mine ? 'justify-end' : 'justify-start'}`}>
                <div className={`max-w-[75%] rounded-2xl px-3 py-2 text-sm border ${mine ? 'bg-[hsl(var(--role-accent)/0.12)] border-[hsl(var(--role-accent)/0.25)]' : 'bg-muted border-border'}`}>
                  <div className="text-[11px] text-muted-foreground">{m.sender_name} · {fmtDate(m.created_at, 'dd MMM, HH:mm')}</div>
                  <div className="whitespace-pre-line">{m.body}</div>
                </div>
              </div>
            );
          })}
          {!items.length && <div className="text-center text-sm text-muted-foreground py-10">No messages yet. Say hi 👋</div>}
          <div ref={endRef} />
        </div>
        <div className="border-t p-3 flex items-center gap-2">
          <Input placeholder="Type a message…" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && send()} data-testid="messages-composer-input" />
          <Button onClick={send} data-testid="messages-send-button"><Send className="h-4 w-4" /></Button>
        </div>
      </Card>
    </div>
  );
}
